import React, { useEffect } from 'react'
import { render } from 'react-dom'
import PropTypes from 'prop-types'
import { P2 } from '../styled/typography/typography'
import { optionallyStyled } from '../../utils/stylecomponents'
import EmbeddedVideo, { VIDEO_PLACEHOLDER_CLASS } from './Loom/EmbeddedVideo'
import { useTheme } from 'styled-components'

const DraftJSRenderer = ({
  content,
  cssClass,
  styleComponent,
  renderVideo = true,
  setContainsVideo,
  id
}) => {
  const theme = useTheme()

  // TODO: find a better way to do this
  useEffect(() => {
    if (renderVideo) {
      const placeholders = document.querySelectorAll(
        `.draft-renderer-embed-video > div.${VIDEO_PLACEHOLDER_CLASS}`
      )
      for (let placeholder of placeholders) {
        const parent = document.createElement('div')
        render(<EmbeddedVideo {...placeholder.dataset} />, parent, () => {
          placeholder.replaceWith(...Array.from(parent.childNodes))
        })
      }
    }

    if (setContainsVideo) {
      const placeholders = document.querySelectorAll(
        `#draft-js-renderer-${id} > div.${VIDEO_PLACEHOLDER_CLASS}`
      )
      setContainsVideo(placeholders.length > 0)
    }
  }, [content])

  const Component = optionallyStyled(styleComponent, P2, cssClass)

  return (
    <Component
      id={id ? `draft-js-renderer-${id}` : undefined}
      className={`markdown ${cssClass} draft-js-output ${
        renderVideo ? 'draft-renderer-embed-video' : ''
      } markdown-${theme?.style}`}
      dangerouslySetInnerHTML={{
        __html: content ? content.replace(/<a/gi, '<a target="_blank"') : ''
      }}
    />
  )
}

DraftJSRenderer.propTypes = {
  content: PropTypes.string,
  cssClass: PropTypes.string,
  styleComponent: PropTypes.elementType,
  renderVideo: PropTypes.bool,
  setContainsVideo: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default DraftJSRenderer
